import { render, staticRenderFns } from "./bank-logs-tab.vue?vue&type=template&id=4bb56444&scoped=true"
import script from "./bank-logs-tab.vue?vue&type=script&lang=js"
export * from "./bank-logs-tab.vue?vue&type=script&lang=js"
import style0 from "./bank-logs-tab.vue?vue&type=style&index=0&id=4bb56444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb56444",
  null
  
)

export default component.exports